"use client";
import React from "react";

const HowItWorksSection = () => {
  const steps = [
    {
      number: "01",
      title: "Upload Jobs",
      description: "Simply upload your job descriptions and requirements. Our AI understands the context and creates tailored interview questions."
    },
    {
      number: "02",
      title: "AI Screens Candidates",
      description: "Candidates receive automated invitations. Our AI conducts natural phone or video conversations to qualify them."
    },
    {
      number: "03",
      title: "Review & Hire",
      description: "Get detailed Credo Reports with AI-generated insights. Make faster, data-driven hiring decisions."
    }
  ];

  return (
    <section className="relative py-24 bg-[#F3F1FA]">
      {/* Gradient line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent/30 to-transparent" />
      
      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-accent text-sm font-semibold uppercase tracking-wider mb-4">
            How It Works
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-jacarta-700 mb-4">
            Simple.{" "}
            <span className="text-accent">
              Powerful.
            </span>{" "}
            Fast.
          </h2>
          <p className="text-jacarta-500 text-lg max-w-2xl mx-auto">
            Get started in minutes, not months
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-accent/0 via-accent/30 to-accent/0" />
          
          <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step card */}
                <div className="relative p-8 rounded-2xl bg-white border border-accent/10 hover:border-accent/30 hover:shadow-lg hover:shadow-accent/5 transition-all duration-500 group">
                  {/* Step number */}
                  <div className="absolute -top-4 left-8 px-4 py-1 rounded-full bg-accent text-white text-sm font-bold">
                    {step.number}
                  </div>

                  {/* Content */}
                  <div className="mt-4">
                    <h3 className="text-2xl font-bold text-jacarta-700 mb-4">
                      {step.title}
                    </h3>
                    <p className="text-jacarta-500 leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Hover glow */}
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
